// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1Cxtv","rootSmall":"AddTileButton_rootSmall__3EXZW"};